import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Button } from '@grandvisionhq/common';
import { getICSEvent } from '@grandvisionhq/lib-ics';

const ICSButton = (_param)=>{
    var { appointmentType , className , timeSlot , store , onClick  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "appointmentType",
        "className",
        "timeSlot",
        "store",
        "onClick"
    ]);
    const onButtonClick = React.useCallback(()=>{
        onClick === null || onClick === void 0 ? void 0 : onClick();
        getICSEvent({
            description: appointmentType.description,
            timeSlot,
            name: appointmentType.name,
            location: store,
            id: appointmentType.id
        });
    }, [
        appointmentType,
        timeSlot,
        store,
        onClick
    ]);
    return /*#__PURE__*/ React.createElement(Button, swcHelpers.extends({}, rest, {
        onClick: onButtonClick,
        className: classnames('ics-button', className)
    }));
};
var ICSButton$1 = ICSButton;

export { ICSButton$1 as default };
//# sourceMappingURL=ICSButton.js.map
